<template>
    <b-table 
        striped 
        borderless
        small

        :items="assetList" 
        :fields="tableFields"
        sort-by="symbol"
        class="table table-dark position_table mb-0"
        thead-class="hidden_header"
        id="asset-table"
        >

        <template #cell(asset_data)="data">
            <b-row class="pl-2">
                <b-col>
                    <asset-symbol :asset="data.item" />
                </b-col>
                <b-col cols="3" class="format-price">
                    <span v-if="data.item.cached_stats?.lowest_open_position">
                        {{ formatPrice(data.item.cached_stats.lowest_open_position.open_price) }}
                    </span>
                    <span v-else>
                        N/A
                    </span>
                </b-col>
                <b-col class="format-price" :class="currentPriceClass(data.item)">
                    {{ formatPrice(data.item.price) }}
                    <span v-if="data.item.meta && ['100k'].includes(data.item.meta.conviction) && data.item.cached_stats?.lowest_open_position">
                        <price-distance :openPrice="data.item.cached_stats.lowest_open_position.open_price" :currentPrice="data.item.price" />
                    </span>
                </b-col>
            </b-row>
        </template>
    </b-table>
</template>

<script>
import formatter from '../../mixins/formatter';

import AssetSymbol from '../style/AssetSymbol.vue';
import PriceDistance from '../style/PriceDistance.vue';

export default {
    name: 'AssetList',
    props: {
        assetList: Array,
        highlightBelowOpen: { type: Boolean, default: false },
    },
    mixins: [formatter],
    components: {
        AssetSymbol,
        PriceDistance
    },

    data() {
        return {
            tableFields: [
                {
                    key: 'score',
                    label: 'score',
                    thClass: 'd-none', 
                    tdClass: 'd-none',                 
                },
                {
                    key: 'asset_data',
                    label: 'asset',
                    tdClass: 'py-3', 
                },
            ],
        }
    },

    methods: {
        currentPriceClass(asset) {
            if (!this.highlightBelowOpen) return '';

            const lowestOpen = asset.cached_stats?.lowest_open_position?.open_price;
            if (!lowestOpen || lowestOpen <= asset.price) return '';

            return 'price_below_open';
        }
    }
};
</script>

<style>
.hidden_header {
    display: none;
}
/* a red tint, deliberately softer than $danger's alert red */
.price_below_open {
    color: #ea868f;
}
</style>